import * as React from 'react';
import { st, classes } from './CoreAutocomplete.st.css';
import { CoreInputWithOptions } from '../CoreInputWithOptons';
import { OptionFactory } from '../CoreDropdownOption/OptionFactory';
import { filterDataProps } from '../../utils/FilterDataProps';
const createDivider = (value = null) => OptionFactory.createDivider({ className: classes.divider, value });
export class CoreAutocomplete extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = { inputValue: '' };
        this._onInputChange = (event) => {
            if (this.state.inputValue !== event.target.value) {
                this.setState({
                    inputValue: event.target.value,
                });
                const { onChange } = this.props;
                onChange && onChange(event);
            }
        };
        this._onSelect = (option) => {
            if (this.state.inputValue !== this._getDisplayValue(option)) {
                this.setState({
                    inputValue: this._getDisplayValue(option),
                });
                const { onSelect } = this.props;
                onSelect && onSelect(option);
            }
        };
        this._onInitialSelectedOptionsSet = (options) => {
            const selectedValue = options.length
                ? this._getDisplayValue(options[0])
                : '';
            if (selectedValue && this.state.inputValue !== selectedValue) {
                this.setState({
                    inputValue: selectedValue,
                });
            }
        };
    }
    _createInputProps() {
        const { inputValue } = this.state;
        const { autoFocus, disabled, onBlur, onFocus, placeholder, error, prefix, suffix, inputProps, } = this.props;
        return {
            ...inputProps,
            value: inputValue,
            onChange: this._onInputChange,
            autoFocus,
            disabled,
            onBlur,
            onFocus,
            placeholder,
            error,
            suffix,
            prefix,
            'aria-autocomplete': 'both',
        };
    }
    _getDisplayValue(option) {
        return option.displayText || option.value;
    }
    _handleContentMouseDown(e) {
        e.preventDefault(); // Prevent input blur from stopping click event
    }
    render() {
        const { options, initialSelectedId, fixedHeader, fixedFooter, onManualInput, disabled, className, inputId, } = this.props;
        const inputProps = this._createInputProps();
        return (React.createElement(CoreInputWithOptions, { className: st(classes.root, { disabled }, className), onSelect: this._onSelect, initialSelectedIds: initialSelectedId || initialSelectedId === 0
                ? [initialSelectedId]
                : null, onInitialSelectedOptionsSet: this._onInitialSelectedOptionsSet, fixedHeader: fixedHeader, fixedFooter: fixedFooter, onManualInput: onManualInput, options: options, inputProps: inputProps, id: inputId ? inputId : null, onContentMouseDown: this._handleContentMouseDown, ...filterDataProps(this.props) }));
    }
}
CoreAutocomplete.displayName = 'CoreAutocomplete';
CoreAutocomplete.createOption = OptionFactory.create;
CoreAutocomplete.createDivider = createDivider;
//# sourceMappingURL=CoreAutocomplete.js.map